// 数据api请求接口
export default {
    // 首页数据
    indexinfo: {
        url: "/api/content/home",
        method: "post",
    },
    // Banner列表
    bannerscontent: {
        url: "/api/content/banners",
        method: "post",
    },
    // 通知公告列表
    noticescontent: {
        url: "/api/content/notices",
        method: "post",
    },
    //通知公告详情
    noticedetailcontent: {
        url: "/api/content/noticedetail",
        method: "post",
    },
    // 单页内容/用户服务协议
    pagecontent: {
        url: "/api/content/page",
        method: "post",
    },
    //提交留言反馈
    feedbackcontent: {
        url: "/api/content/feedback",
        method: "post",
    },
     //公共说明-统一返回与状态枚举
     standardcommon: {
        url: "/api/common/response-standard",
        method: "post",
    },
     //发送短信验证码
     sendsms: {
        url: "/api/sms/send",
        method: "post",
    },
     //用户注册
     registeruser: {
        url: "/api/user/register",
        method: "post",
    },
     //用户登录
     loginuser: {
        url: "/api/user/login",
        method: "post",
    },
     //忘记密码/重置密码
     resetpwduser: {
        url: "/api/user/resetpwd",
        method: "post",
    },
     //退出登录
     logoutuser: {
        url: "/api/user/logout",
        method: "post",
    },
     //获取当前用户信息
     indexuser: {
        url: "/api/user/index",
        method: "post",
    },
     //修改用户资料
     profileuser: {
        url: "/api/user/profile",
        method: "post",
    },
     //店铺设置
     settingshop: {
        url: "/api/shop/setting",
        method: "post",
    },
     //商铺字典
     categoriesshop: {
        url: "/api/shop/categories",
        method: "post",
    },
     //省份列表
     provincecommon: {
         url: "/api/common/province",
         method: "post",
     },
     //城市列表
     citiesshop: {
         url: "/api/shop/cities",
         method: "post",
     },
     //商铺列表
     listshop: {
        url: "/api/shop/list",
        method: "post",
    },
     //商铺详情
     detailshop: {
        url: "/api/shop/detail",
        method: "post",
    },
     //用户发布商铺
     publishshop: {
        url: "/api/shop/publish",
        method: "post",
    },
     //我的发布
     mineshop: {
        url: "/api/shop/mine",
        method: "post",
    },
     //收藏商铺
     favoriteshop: {
        url: "/api/shop/favorite",
        method: "post",
    },
     //取消收藏
     unfavoriteshop: {
        url: "/api/shop/unfavorite",
        method: "post",
    },
     //我的收藏
     favoritesshop: {
        url: "/api/shop/favorites",
        method: "post",
    },
     //成交案例列表
     dealsshop: {
        url: "/api/shop/deals",
        method: "post",
    },
    //成交案例详情 api/shop/dealdetail
    dealdetailshop: {
        url: "/api/shop/dealdetail",
        method: "post",
    },
    //出租详情 
    rentdetailshop: {
        url: "/api/shop/rentdetail",
        method: "post",
    },
     //首页成交视频案例
     dealvideospc: {
        url: "/api/pc/dealvideos",
        method: "post",
    },
    //成交视频案例列表 
    dealvideoscontent: {
        url: "/api/content/dealvideos",
        method: "post",
    },
     //成交视频案例详情
     dealvideodetailcontent: {
        url: "/api/content/dealvideodetail",
        method: "post",
    },
    //首页最新成交数据 
    latestdealspc: {
        url: "/api/pc/latestdeals",
        method: "post",
    },
     //最新成交列表
     latestdealscontent: {
        url: "/api/content/latestdeals",
        method: "post",
    },
    //首页最新求租 
    latestwantedpc: {
        url: "/api/pc/latestwanted",
        method: "post",
    },
    //求租列表 
    wantedshop: {
        url: "/api/shop/wanted",
        method: "post",
    },
    //求租详情 
    wanteddetailshop: {
        url: "/api/shop/wanteddetail",
        method: "post",
    },
    //根据城市获取区域 
    subareaspc: {
        url: "/api/pc/subareas",
        method: "post",
    },
    //根据定位获取城市 
    resolvecitybylocationpc: {
        url: "/api/pc/resolvecitybylocation",
        method: "post",
    },
     //招商项目详情
     detailinvestment: {
        url: "/api/investment/detail",
        method: "post",
    },
     //上传图片/视频
     uploadcommon: {
        url: "/api/common/upload",
        method: "post",
    },
     //获取城市区域
     subareasminiapp: {
        url: "/api/pc/subareas",
        method: "post",
    },
    //首页展示标签获取数据 
    listingsbydisplaytagminiapp: {
        url: "/api/pc/listingsbydisplaytag",
        method: "post",
    },
    //生意转让 
    transfersshop: {
        url: "/api/shop/transfers",
        method: "post",
    },
    //转让详情 
    transferdetailshop: {
        url: "/api/shop/transferdetail",
        method: "post",
    },
    //商铺出租 
    rentsshop: {
        url: "/api/shop/rents",
        method: "post",
    },
    //招商合租列表 
    projectsinvestment: {
        url: "/api/investment/projects",
        method: "post",
    },
    //品牌合作列表 
    brandcooperationsinvestment: {
        url: "/api/investment/brandcooperations",
        method: "post",
    },
    //走进铭顺 
    aboutminiapp: {
        url: "/api/pc/about",
        method: "post",
    },
    //协议 
    policiesminiapp: {
        url: "/api/pc/policies",
        method: "post",
    },
    //搜索 
    searchlistingsminiapp: {
        url: "/api/pc/searchlistings",
        method: "post",
    },
    //用户信息 
    miniuserinfouser: {
        url: "/api/user/miniuserinfo",
        method: "post",
    },
    //修改用户信息 
    miniprofileuser: {
        url: "/api/user/miniprofile",
        method: "post",
    },
    //更换手机号 
    minichangemobileuser: {
        url: "/api/user/minichangemobile",
        method: "post",
    },
    //编辑我的发布
    updateshop: {
        url: "/api/shop/update",
        method: "post",
    },
    //附近城市推荐 
    nearbycitiesshop: {
        url: "/api/shop/nearbycities",
        method: "post",
    },
    //周边区域推荐 
    nearbyareasshop: {
        url: "/api/shop/nearbyareas",
        method: "post",
    },
    //新增商铺转让 
    transfernewapi: {
        url: "/api/newapi/transfer",
        method: "post",
    },
     //新增商铺出租 
     rentnewapi: {
        url: "/api/newapi/rent",
        method: "post",
    },
      //新增商铺求租 
      wantednewapi: {
        url: "/api/newapi/wanted",
        method: "post",
    },
      //编辑商铺转让 
      transfereditnewapi: {
        url: "/api/newapi/transferedit",
        method: "post",
    },
       //编辑商铺出租 
       renteditnewapi: {
        url: "/api/newapi/rentedit",
        method: "post",
    },
        //编辑商铺求租 
        wantededitnewapi: {
            url: "/api/newapi/wantededit",
            method: "post",
        },
        //提交经纪人认证  
        brokersubmituser: {
            url: "/api/user/brokersubmit",
            method: "post",
        },
        //获取经纪人认证信息 
        brokerinfouser: {
            url: "/api/user/brokerinfo",
            method: "post",
        },
        //验证码登陆 
        mobileloginuser: {
            url: "/api/user/mobilelogin",
            method: "post",
        },
        //三级联动省市区 
        subareasshop: {
            url: "/api/shop/subareas",
            method: "post",
        },
        //新的省市区接口  api/shop/areas
        areasshop: {
            url: "/api/shop/areas",
            method: "post",
        },
        //下架我的发布吧  api/shop/offline
        shopdelete: {
            url: "/api/shop/delete",
            method: "post",
        },
        // 发布视频房源（与小程序 pages/mine/Videoproperty 一致）
        videopropertyshop: {
            url: "/api/newapi/video",
            method: "post",
        },
}